import React from 'react';

const SettingsPanel = ({
    visible,
    longCountdown,
    shortCountdown,
    setLongCountdown,
    setShortCountdown,
    onClose,
    onSave,
    singleCountdown = false,
    countdown,
    setCountdown,
    countdownKey = 'prosodyCountdown'
}) => {
    if (!visible) return null;

    const handleLongChange = (e) => {
        const value = Math.max(1, parseInt(e.target.value, 10) || 0);
        if (setLongCountdown) setLongCountdown(value);
    };

    const handleShortChange = (e) => {
        const value = Math.max(1, parseInt(e.target.value, 10) || 0);
        if (setShortCountdown) setShortCountdown(value);
    };

    const handleCountdownChange = (e) => {
        const value = Math.max(1, parseInt(e.target.value, 10) || 0);
        if (setCountdown) setCountdown(value);
    };

    const handleSave = () => {
        if (onSave) {
            if (singleCountdown) {
                onSave({ [countdownKey]: countdown });
            } else {
                onSave({
                    preferredLongCountdown: longCountdown,
                    preferredShortCountdown: shortCountdown
                });
            }
        }
        onClose();
    };

    return (
        <div className="settings-overlay" onClick={onClose}>
            <div className="settings-panel" onClick={e => e.stopPropagation()}>
                <h3>Countdown Settings</h3>
                {singleCountdown ? (
                    <label>
                        Countdown (seconds)
                        <input
                            type="number"
                            min="1"
                            value={countdown}
                            onChange={handleCountdownChange}
                            className="countdown-input"
                        />
                    </label>
                ) : (
                    <>
                        <label>
                            Long Countdown (seconds)
                            <input
                                type="number"
                                min="1"
                                value={longCountdown}
                                onChange={handleLongChange}
                                className="countdown-input"
                            />
                        </label>
                        <label>
                            Short Countdown (seconds)
                            <input
                                type="number"
                                min="1"
                                value={shortCountdown}
                                onChange={handleShortChange}
                                className="countdown-input"
                            />
                        </label>
                    </>
                )}
                <button className="save-button" onClick={handleSave}>Save Settings</button>
            </div>
        </div>
    );
};

export default SettingsPanel;
